import type { ReactNode } from 'react';

/** A card of labelled numbers (style guide 2.104): heading, optional link, figure tiles, optional note. */
export function FigureGroup({ title, note, action, children }: { readonly title: string; readonly note?: string; readonly action?: ReactNode; readonly children: ReactNode }) {
  return (
    <section className="ui-card ui-stack" aria-label={title}>
      <div className="ui-console-figures__head">
        <h2 className="ui-console-figures__title">{title}</h2>
        {action}
      </div>
      <dl className="ui-console-figures">{children}</dl>
      {note ? <p className="ui-console-muted">{note}</p> : null}
    </section>
  );
}

/** `text`: a word, date or address instead of a number (smaller type); `wide`: spans the whole row. */
export function Figure({ label, value, text, wide }: { readonly label: string; readonly value: ReactNode; readonly text?: boolean; readonly wide?: boolean }) {
  return (
    <div className={wide ? 'ui-console-figure ui-console-figure--wide' : 'ui-console-figure'}>
      <dt className="ui-console-figure__label">{label}</dt>
      <dd className={text ? 'ui-console-figure__value ui-console-figure__value--text' : 'ui-console-figure__value'}>{value}</dd>
    </div>
  );
}
